<template>
    <article class="upload-field">
        <b-card :img-src="input"
                img-top
                class="mb-2">
            <slot></slot>
            <upload-field
                :name="name"
                :label="label"
                :readonly="readonly"
                :value="input"
                @input="handleInput"
            />
        </b-card>
    </article>
</template>

<script>
import UploadField from "./UploadField.vue";
import field from "../../Mixins/field";

export default {
  mixins: [field],
  components: { UploadField },
  props: {
    name: {},
    label: {
      default: "Upload Image"
    }
  },
  methods: {
    handleInput(input) {
      this.input =
        "https://" + _CONFIG.S3_BUCKET + ".s3.amazonaws.com/" + input;
      this.$emit("input", this.input);
    }
  }
};
</script>